export const matchesSelector = (element, selector) => {
    let matches = false;
    try {
        matches = (element.matches || element.msMatchesSelector).call(element, selector);
    }
    catch (e) {
        // Fails on invalid or unknown selectors
    }
    return matches;
};
//# sourceMappingURL=matchesSelector.js.map